module.exports = "<div class=\"text-center\">\r\n  <div class=\"table-responsive\">\r\n    <app-ssn-table [entryData]=organizationProperties></app-ssn-table>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/organization-info-table/organization-info-table.component.html
// module id = ./src/app/shared/components/organization-info-table/organization-info-table.component.html
// module chunks = main